// i18n area 'tasks' — locale el-GR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.el-GR.meta.json.
import type { enUS } from './tasks'

export const elGR: typeof enUS = {
  macrotasks: {
    title: 'Μακροεργασίες',
    subtitle: 'Σύνθετες λειτουργίες — με δυνατότητα επανάληψης από το βήμα που απέτυχε, ή ματαίωσης',
    colType: 'Τύπος',
    colTarget: 'Στόχος',
    colPhase: 'Φάση',
    colSteps: 'Βήματα',
    empty: 'Καμία μακροεργασία',
    detail: 'Λεπτομέρειες',
    failedAt: 'απέτυχε σε',
    resume: 'Νέα προσπάθεια από το βήμα που απέτυχε',
    abort: 'Ματαίωση όλων',
    cancel: 'Ακύρωση',
    actionError: 'Η ενέργεια απορρίφθηκε'
  },
  tasks: {
    title: 'Εργασίες',
    searchPlaceholder: 'Αναζήτηση κατά τύπο ή στόχο',
    type: 'Τύπος',
    target: 'Στόχος',
    phaseLabel: 'Φάση',
    progress: 'Πρόοδος',
    started: 'Έναρξη',
    finished: 'Λήξη',
    node: 'Κόμβος',
    empty: 'Καμία εργασία',
    loadError: 'Δεν ήταν δυνατή η φόρτωση των εργασιών — είναι προσβάσιμο το backend του TVirt;',
    limboHint: 'Ο κόμβος «{node}» δεν είναι προσβάσιμος από τις {time} — η εργασία κρατά το write lease στον στόχο της μέχρι ο κόμβος να επιστρέψει ή να βεβαιωθεί απενεργοποιημένος',
    nodeAttested: 'Ο κόμβος βεβαιώθηκε απενεργοποιημένος',
    phase: {
      queued: 'Σε ουρά',
      running: 'Εκτελείται',
      succeeded: 'Ολοκληρώθηκε',
      failed: 'Απέτυχε',
      cancelled: 'Ακυρώθηκε',
      'failed-at-step': 'Απέτυχε σε βήμα',
      aborted: 'Ματαιώθηκε'
    },
    dropdown: {
      tooltip: 'Εργασίες σε εξέλιξη',
      title: 'Εργασίες σε εξέλιξη',
      empty: 'Καμία εργασία σε εξέλιξη',
      viewAll: 'Προβολή όλων των εργασιών'
    },
    detail: {
      open: 'Λεπτομέρειες',
      scope: 'Scope',
      message: 'Μήνυμα',
      params: 'Παράμετροι',
      result: 'Αποτέλεσμα',
      errorTitle: 'Σφάλμα',
      steps: 'Βήματα',
      failedAt: 'απέτυχε σε',
      superseded: 'αντικαταστάθηκε',

      // Τυπικό παράθυρο διαλόγου (round #156): η θέση της θυγατρικής εργασίας στο
      // πλάνο της γονικής, η ίδια η γονική (ανοίγει επιτόπου) και το ένοχο βήμα.
      step: 'Βήμα',
      parent: 'Γονική εργασία',
      failedStep: 'Βήμα που απέτυχε',
      log: 'Καταγραφή',
      logEmpty: 'Καμία εγγραφή καταγραφής ακόμη',
      close: 'Κλείσιμο'
    },
    actions: {
      cancel: 'Ακύρωση',
      resume: 'Νέα προσπάθεια από το βήμα που απέτυχε',
      abort: 'Ματαίωση όλων (αναίρεση των ολοκληρωμένων βημάτων)',
      refused: 'Η ενέργεια απορρίφθηκε'
    }
  },
  events: {
    loadError: 'Δεν ήταν δυνατή η φόρτωση του ημερολογίου — είναι προσβάσιμο το backend του TVirt;',
    title: 'Συμβάντα',
    subtitle: 'Η ιστορική μνήμη του cluster: τετελεσμένα γεγονότα, από τα πιο πρόσφατα',
    filterSeverity: 'Σοβαρότητα',
    filterCategory: 'Κατηγορία',
    filterAll: 'Όλες',
    searchLabel: 'Αναζήτηση',
    searchPlaceholder: 'Αναζήτηση σε όλο το ημερολόγιο',
    subjectFilter: 'Συμβάντα του {subject} — εμφάνιση όλων',
    colAt: 'Πότε',
    colSeverity: 'Σοβαρότητα',
    colType: 'Τύπος',
    colSubject: 'Αντικείμενο',
    colActor: 'Ποιος',
    colNode: 'Node',
    colMessage: 'Μήνυμα',
    empty: 'Κανένα συμβάν',
    loadMore: 'Φόρτωση περισσότερων',
    actorSystem: 'σύστημα',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'ID συμβάντος',
    taskCollectedHint: 'Το task έχει μικρότερη διατήρηση: μόλις συλλεχθεί ο σύνδεσμος δεν απαντά πια',
    severity: {
      info: 'Πληροφορία',
      warning: 'Προειδοποίηση',
      error: 'Σφάλμα',
      critical: 'Κρίσιμο'
    },
    category: {
      lifecycle: 'Κύκλος ζωής',
      config: 'Διαμόρφωση',
      availability: 'Διαθεσιμότητα',
      security: 'Ασφάλεια'
    },
    type: {
      haNetsvcFailedOver: 'Failover υπηρεσίας δικτύου',
      haNetsvcNoCandidate: 'Υπηρεσία δικτύου χωρίς υποψήφιο κόμβο',
      haNetsvcReaped: 'Τοπική παρουσία θερίστηκε στην επανένταξη του κόμβου',
      netsvcFloatipMoved: 'Η κινητή IP μετακινήθηκε σε άλλον κάτοχο',
      netsvcFloatipNoHolder: 'Κινητή IP χωρίς υγιή στόχο',
      haAppFailedOver: 'Failover της περίπτωσης App',
      haAppNoCandidate: 'Περίπτωση App χωρίς υποψήφιο κόμβο',
      haAppStorageLocalSkip: 'Η περίπτωση App δεν μεταφέρθηκε: μόνιμα δεδομένα τοπικά στον νεκρό κόμβο',
      haAppReaped: 'Το τοπικό pod της περίπτωσης App θερίστηκε κατά την επανένταξη'
    }
  },
  audit: {
    loadError: 'Δεν ήταν δυνατή η φόρτωση του μητρώου ελέγχου — είναι προσβάσιμο το backend του TVirt;',
    title: 'Έλεγχος',
    subtitle: 'Ποιος έκανε τι, πότε, σε ποιο αντικείμενο — επιχειρούμενες πράξεις, μαζί με τις αρνήσεις',
    filterOutcome: 'Έκβαση',
    filterAll: 'Όλες',
    filterSudo: 'Μόνο ανυψωμένες πράξεις',
    colAt: 'Πότε',
    colActor: 'Ποιος',
    colAction: 'Ενέργεια',
    colTarget: 'Αντικείμενο',
    colOutcome: 'Έκβαση',
    colNode: 'Node',
    empty: 'Καμία καταγεγραμμένη πράξη',
    loadMore: 'Φόρτωση περισσότερων',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Διαδρομή',
    detailProblem: 'Αιτία',
    detailTask: 'Task',
    detailClientIp: 'Από',
    detailId: 'ID εγγραφής',
    detailSession: 'Συνεδρία',
    taskHint: 'Η έκβαση μιας αποδεκτής πράξης ζει στο ημερολόγιο συμβάντων, κάτω από το ίδιο id του task',
    outcome: {
      succeeded: 'Ολοκληρώθηκε',
      accepted: 'Έγινε δεκτή',
      denied: 'Δεν επιτράπηκε',
      rejected: 'Απορρίφθηκε',
      failed: 'Απέτυχε'
    }
  },
  notifications: {
    loadError: 'Δεν ήταν δυνατή η φόρτωση των ειδοποιήσεων — είναι προσβάσιμο το backend του TVirt;',
    actionError: 'Η ενέργεια απορρίφθηκε',
    title: 'Ειδοποιήσεις',
    subtitle: 'Οι προορισμοί προς τους οποίους τα γεγονότα του ημερολογίου φεύγουν από τη συστοιχία',
    rulesTitle: 'Κανόνες',
    rulesSubtitle: 'Ποια γεγονότα φεύγουν και προς πού',
    deliveriesTitle: 'Παραδόσεις',
    deliveriesSubtitle: 'Το αποτέλεσμα κάθε ειδοποίησης, με τον λόγο όταν αποτυγχάνει',
    colName: 'Όνομα',
    colKind: 'Τύπος',
    colWhere: 'Πού',
    colScope: 'Scope',
    colSeverity: 'Σοβαρότητα',
    colMatch: 'Φίλτρο',
    colTargets: 'Προορισμός',
    colAt: 'Πότε',
    colState: 'Κατάσταση',
    colEvent: 'Συμβάν',
    colAttempts: 'Προσπάθειες',
    colOutcome: 'Αποτέλεσμα',
    empty: 'Καμία γραμμή',
    matchAll: 'όλα τα γεγονότα',
    test: 'Δοκιμή',
    testOk: 'Δοκιμαστική ειδοποίηση παραδόθηκε στο {target}',
    testFailed: 'Η δοκιμή προς {target} απέτυχε: {reason}',
    retry: 'Επανατοποθέτηση στην ουρά',
    retried: 'Η παράδοση επανατοποθετήθηκε στην ουρά',
    grouped: 'και άλλες {count} επαναλήψεις',
    state: {
      failed: 'Απέτυχε',
      pending: 'Σε ουρά',
      sending: 'Αποστέλλεται',
      sent: 'Εστάλη'
    },
    tabTargets: 'Προορισμοί',
    tabRules: 'Κανόνες',
    tabDeliveries: 'Παραδόσεις',
    targetCreateTitle: 'Νέος προορισμός',
    ruleCreateTitle: 'Νέος κανόνας',
    nameHint: 'Πεζά, ψηφία και παύλες· μοναδικό ανά εμβέλεια',
    kindImmutableHint: 'Αμετάβλητο: η αλλαγή τύπου σημαίνει δημιουργία άλλου προορισμού',
    kindSmtp: 'Αλληλογραφία (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Κατάσταση',
    enabledOn: 'Ενεργός',
    enabledOff: 'Σε αναστολή',
    smtpHost: 'Διακομιστής SMTP',
    smtpPort: 'Θύρα',
    smtpPortHint: 'Συνήθως: 25 χωρίς TLS, 587 με starttls, 465 με tls',
    smtpSecurity: 'Ασφάλεια',
    smtpFrom: 'Αποστολέας',
    smtpTo: 'Παραλήπτες',
    smtpToHint: 'Μία ή περισσότερες διευθύνσεις χωρισμένες με κόμμα',
    webhookUrl: 'URL',
    payload: 'Περιεχόμενο',
    payloadHint: 'Με minimal το μήνυμα και τα δεδομένα του γεγονότος δεν φεύγουν από το cluster',
    credential: 'Διαπιστευτήριο',
    credentialNone: 'Κανένα',
    credentialHintSmtp: 'Ο λογαριασμός του relay από το keystore· κανένα σημαίνει ανώνυμο SMTP',
    credentialHintWebhook: 'Το μυστικό υπογραφής από το keystore· χωρίς υπογραφή, όποιος γνωρίζει το URL μπορεί να παρουσιαστεί ως το cluster',
    minSeverityHint: 'Κατώφλι, όχι σύνολο: από αυτή τη σοβαρότητα και πάνω',
    categories: 'Κατηγορίες',
    categoriesHint: 'Κενό = όλες',
    types: 'Τύποι γεγονότων',
    typesHint: 'Χωρισμένοι με κόμμα· κενό = όλοι. Ένας άγνωστος τύπος απορρίπτεται',
    targetsHint: 'Τουλάχιστον ένας· πρέπει να βρίσκονται στην εμβέλεια του κανόνα ή σε πρόγονό της',
    recursiveOn: 'Και οι θυγατρικές εμβέλειες',
    recursiveOff: 'Μόνο αυτή η εμβέλεια',
    recursiveHint: 'Οι πόροι ζουν στα φύλλα: χωρίς τα παιδιά, ένας κανόνας στη ρίζα ειδοποιεί σχεδόν για τίποτα',
    repeatWindow: 'Παράθυρο ομαδοποίησης (s)',
    repeatWindowHint: 'Μέσα στο παράθυρο οι επαναλήψεις δεν στέλνουν αλληλογραφία: μετρώνται στην πρώτη. Το 0 απενεργοποιεί',
    targetInUseError: 'Ο προορισμός {name} χρησιμοποιείται ακόμη από κανόνα'
  }
}
